var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { IconReleased, IconX } from '@spotify-internal/encore-web';
import React from 'react';
import { DateRangePicker as AirbnbDateRangePicker, SingleDatePicker as AirbnbSingleDatePicker, } from 'react-dates';
export { DayPickerRangeController, DayPickerSingleDateController, isInclusivelyAfterDay, isInclusivelyBeforeDay, isNextDay, isSameDay, toISODateString, toLocalizedDateString, toMomentObject, } from 'react-dates';
export { ReactDatesThemeProvider } from './ReactDatesThemeProvider';
export function DateRangePicker(props) {
    var customCloseIcon = props.customCloseIcon || (props.showClearDates ? React.createElement(IconX, null) : undefined);
    var customInputIcon = props.customInputIcon || (props.showDefaultInputIcon ? React.createElement(IconReleased, null) : undefined);
    return (React.createElement(AirbnbDateRangePicker, __assign({}, props, { customCloseIcon: customCloseIcon, customInputIcon: customInputIcon, showDefaultInputIcon: false })));
}
export function SingleDatePicker(props) {
    var customCloseIcon = props.customCloseIcon || (props.showClearDate ? React.createElement(IconX, null) : undefined);
    var customInputIcon = props.customInputIcon || (props.showDefaultInputIcon ? React.createElement(IconReleased, null) : undefined);
    return (React.createElement(AirbnbSingleDatePicker, __assign({}, props, { customCloseIcon: customCloseIcon, customInputIcon: customInputIcon, showDefaultInputIcon: false })));
}
//# sourceMappingURL=index.js.map